import * as yup from 'yup';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useMutation } from 'react-query';
import { yupErrorMsg } from '../../../components/atoms/const';
import api from '../../../components/api';

function useSignup() {
  /* Fetching with custom hook to for handling error, loading, and result */
  /* state management for react query fetch management */
  const { isLoading, mutate } = useMutation(api.auth.postRegister, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => console.log(res),
    onError: (err) => console.log('err', err),
  });

  /* State management for Stepper */
  const [step, setStep] = useState(0);
  const handleStep = (num : number) => setStep(num);

  /* form value manager */
  const [formValue, setFormValue] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    firstname: '',
    lastname: '',
    position: '',
    companyName: '',
    address: {
      streetAddress: '',
      zipCode: '',
      state: '',
      city: '',
    },
    phoneNumber: '',
    role: 1,
  });

  /* form validation user login */
  const yupSchemaStep1 = yup.object({
    username: yup.string().email(yupErrorMsg.EMAIL_INCORRECT_FORMAT).required(yupErrorMsg.USERNAME_EMPTY),
    password: yup.string().matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
      yupErrorMsg.PASSWORD_INCORRECT_FORMAT,
    ).required(yupErrorMsg.PASSWORD_EMPTY),
    confirmPassword: yup.string().oneOf([yup.ref('password'), null], yupErrorMsg.PASSWORD_NOT_MATCH)
      .required(yupErrorMsg.CONFIRM_PASS_EMPTY),
  });

  /* form handler user login */
  const formikStep1 = useFormik({
    initialValues: {
      username: formValue.username,
      password: formValue.password,
      confirmPassword: formValue.confirmPassword,
    },
    validationSchema: yupSchemaStep1,
    onSubmit: (values) => {
      const newValue = { ...formValue, ...values };
      console.log(newValue);
      handleStep(1);
      setFormValue(newValue);
    },
  });

  /* form validation personal info */
  const yupSchemaStep2 = yup.object({
    firstname: yup.string().required(yupErrorMsg.FIRST_NAME_EMPTY),
    lastname: yup.string().required(yupErrorMsg.LAST_NAME_EMPTY),
    phoneNumber: yup.string().required(yupErrorMsg.PHONE_NUMBER_EMPTY),
    position: yup.string().required(yupErrorMsg.POSITION_EMPTY),
  });

  /* form handler personal info */
  const formikStep2 = useFormik({
    initialValues: {
      firstname: formValue.firstname,
      lastname: formValue.lastname,
      phoneNumber: formValue.phoneNumber,
      position: formValue.position,
    },
    validationSchema: yupSchemaStep2,
    onSubmit: (values) => {
      const newValue = { ...formValue, ...values };
      console.log(newValue);
      handleStep(2);
      setFormValue(newValue);
    },
  });

  /* form validation personal info */
  const yupSchemaStep3 = yup.object({
    companyName: yup.string().required(yupErrorMsg.COMPANY_NAME_EMPTY),
    streetAddress: yup.string().required(yupErrorMsg.STREET_ADDRESS_EMPTY),
    zipCode: yup.number().required(yupErrorMsg.ZIP_CODE_EMPTY).test('len', yupErrorMsg.ZIP_CODE_INCORRECT_FORMAT, (val: any) => (val ? val.toString().length === 5 : false)),
    state: yup.string().required(yupErrorMsg.STATE_EMPTY),
    city: yup.string().required(yupErrorMsg.CITY_EMPTY),
  });

  /* form handler personal info */
  const formikStep3 = useFormik({
    initialValues: {
      companyName: formValue.companyName,
      streetAddress: formValue.address.streetAddress,
      zipCode: formValue.address.zipCode,
      state: formValue.address.state,
      city: formValue.address.city,
    },
    validationSchema: yupSchemaStep3,
    onSubmit: (values) => {
      const newFormValue = {
        ...formValue,
        companyName: values.companyName,
        address: {
          city: values.city,
          state: values.state,
          streetAddress: values.streetAddress,
          zipCode: values.zipCode,
        },
      };
      console.log(newFormValue);
      setFormValue(newFormValue);
      mutate(newFormValue);
    },
  });

  return {
    isLoading,
    formikStep1,
    formikStep2,
    formikStep3,
    step,
    handleStep,
  };
}

export default useSignup;
